import * as React from 'react';
import { EmployeeDto, Roles } from '../pages/user/userTypes';
import { Route, RouteProps } from 'react-router';
import { hasMinRole } from '../security/permissions';
import ForbiddenPage from '../pages/error/ForbiddenPage';

interface Props extends RouteProps {
  minRole: Roles
  currentAccount: EmployeeDto
  updateCurrentIndex: (currentIndex: number) => void;
}

class RestrictedRoute extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
  }

  public render() {
    return (
      <>
        {
          hasMinRole(this.props.minRole, this.props.currentAccount) ?
          <Route {...this.props}/> :
            <Route path={this.props.path} render={
              () => {
                this.props.updateCurrentIndex(-1);
                return(<ForbiddenPage/>);
              }} />
        }
      </>

    );
  }
}

export default RestrictedRoute;
